import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { FertilizacionService } from "../../../generated/grpc/fertilizacion_pb";
import { grpcFertilizacionDatabase } from "../database/GrpcFertilizacionDatabase";
import { FertilizacionParseRequest } from "../request/FertilizacionParseRequest";
import { AnalisisLaboratorioResponse } from "../response/AnalisisLaboratorioResponse";
import { fx_createFertilizacionGrpcService, toAnalisisLaboratorioResponse } from "./FertilizacionGrpcService";

/** Variante gRPC-Web de `FertilizacionParseService` (ver ese archivo): mismo
 *  contrato `ISaveService`. El Excel ya está subido a Storage antes de esta
 *  llamada (`blobUrl` viene resuelto) — acá solo se manda la URL, el server
 *  descarga el archivo y llama al microservicio externo. */
export class FertilizacionParseGrpcService
  implements ISaveService<FertilizacionParseRequest, AnalisisLaboratorioResponse>
{
  async saveAsync(
    request: FertilizacionParseRequest,
  ): Promise<AnalisisLaboratorioResponse> {
    const client = createClient(FertilizacionService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.parsear({
        fincaId: request.fincaId,
        blobUrl: request.blobUrl ?? "",
        fechaAnalisis: request.fechaAnalisis,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcFertilizacionDatabase.putOneAsync(saved);
    fx_createFertilizacionGrpcService(request.fincaId).clearCache();
    return toAnalisisLaboratorioResponse(saved);
  }
}
